/* CUSTOM — submit-wait-state + scroll-to-success for all contact forms */
(function () {
  function enhance(form) {
    if (form.dataset.contactEnhanced) return;
    form.dataset.contactEnhanced = '1';

    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"].contact-btn');
      if (!btn || btn.disabled) return;
      var spin = btn.querySelector('.loading__spinner');
      if (spin) spin.classList.remove('hidden');
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    });
  }

  function scrollToSuccess(root) {
    var box = (root || document).querySelector('[data-contact-success]');
    if (!box) return;
    requestAnimationFrame(function () {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); }
    });
  }

  function init() {
    document.querySelectorAll('form#ContactForm, form.studio-cal__form').forEach(enhance);
    scrollToSuccess(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
